import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Partners from "./Partners";
import CreatePartner from "./CreatePartner";
import PartnerDetails from "./PartnerDetails";
import { withRouter } from "react-router-dom";

class PartnersRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: false
    };
  }
  render() {
    return (
      <div className="admin-partners-view">
        <Switch>
          <Route
            path={`${this.props.match.path}/create`}
            render={props => (
              <CreatePartner {...props} language={this.context.language} />
            )}
          />
          <Route
            path={`${this.props.match.path}/update/:id`}
            render={props => (
              <CreatePartner {...props} language={this.context.language} />
            )}
          />
          <Route
            path={`${this.props.match.path}/details/:id`}
            render={props => (
              <PartnerDetails {...props} language={this.context.language} />
            )}
          />
          <Route
            path="/admin/partners"
            render={props => (
              <Partners {...props} language={this.context.language} />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(PartnersRouter);